import { render, staticRenderFns } from "./TabConfigurator.vue?vue&type=template&id=7323ee47&scoped=true&"
import script from "./TabConfigurator.vue?vue&type=script&lang=js&"
export * from "./TabConfigurator.vue?vue&type=script&lang=js&"
import style0 from "./TabConfigurator.vue?vue&type=style&index=0&id=7323ee47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7323ee47",
  null
  
)

export default component.exports